export const CHANGE_TOKEN = "CHANGE_TOKEN"
export const CHANGE_LANGUAGUE = "CHANGE_LANGUAGUE"
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"